// extracted by mini-css-extract-plugin
export default {"Footer":"App_Footer__0LRsN","GraphSpinner":"App_GraphSpinner__A6NRd","SpinnerOverlay":"App_SpinnerOverlay__dZ13d"};